export default __webpack_public_path__ + "static/media/daisyui.3ab58cbb.svg";